import React from 'react';


function DetailedBalanceCss(){

	const styleTag = `
		body{
			font-family :sans-serif;
			font-size : 12px;
		}
		.headerRow{
			font-weight: bold;
			margin-top:2px;
			font-size:10px;
			display:flex;
		}
		.headerRowChild{
			width:49%;
			margin-left: 1%;
			font-size:12px;
			font-weight:bold;
			margin-bottom:2px;
		}
		.bodyRow{
			text-transform:uppercase;
			font-family:monospace;
			font-size:10px;
			width:100%;
			display:inline-flex;
		}
		.bodyRowChild{
			width:32%;
			margin-left: 1%;
		}
		
		.operationDesc{
			font-weight:bold;
		}
		.operatorName{
			font-size:15px;
			font-weight:bold;
			margin-bottom:4px;
			margin-top:4px;
		}
		.totalCashAvailability, .headerBox{
			border: black;
    		border-style: solid;
    		border-width: 1px;
    		margin-top: 5px;
    		padding-left: 5px;
		}
		.cashAvailability{
		    padding-left: 5px;
    		margin-top: 4px;
		}
		.summary{
			font-size:20px;
			margin-top:15px;
		}
		
		.footerBox{
			border: black;
    		border-style: solid;
    		border-width: 2px;
    		margin-top: 5px;
    		padding-left: 2px;
		}
		.rowBox{
			border: black;
    		border-style: solid;
    		border-width: 2px;
    		margin-top: 10px;
    		padding-left:3px;
		}
		
		.pixel13{
			font-size:13px;
		}
		
		.weekDiscl{
			font-size: 13px;
		    font-weight: bold;
		    margin-left: 2px;
		    margin-top: 1px;
		    border-style: solid;
		    border-width: 1px;
		    padding: 4px;
		}
	`;
	
	return <style>{styleTag}</style>;
}
export default DetailedBalanceCss;